import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

const displayFont =
  'Impact, Haettenschweiler, "Arial Narrow Bold", "Anton", sans-serif';
const bodyFont = 'Inter, "SVN-Gilroy", Arial, sans-serif';

export const MatchScheduleStyle = {
  wrapper: css`
    width: 100%;
    height: 100%;

    .match-schedule-frame {
      position: relative;
      overflow: hidden;
      border-radius: 6px;
      background: #000;
      isolation: isolate;
    }

    .match-schedule-frame::after {
      content: "";
      position: absolute;
      inset: auto 0 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      max-height: 220px;
      background: linear-gradient(
        179.89deg,
        rgba(0, 0, 0, 0) 3%,
        rgba(0, 0, 0, 0.82) 60%
      );
      pointer-events: none;
    }

    .match-schedule-bg {
      position: absolute;
      inset: 0;
      z-index: 0;
      background-color: #000;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      pointer-events: none;
    }

    .match-stadium-layer {
      position: absolute;
      left: 50%;
      bottom: 18%;
      z-index: 0;
      width: 100%;
      height: 100%;
      max-height: 140px;
      transform: translateX(-50%);
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: 100% 100%;
      pointer-events: none;
    }

    .match-schedule-slider {
      position: relative;
      z-index: 2;
      height: 100%;

      .slick-list,
      .slick-track,
      .slick-slide > div {
        height: 100%;
      }

      .slick-track {
        display: flex !important;
      }

      .slick-slide {
        height: auto;
      }
    }

    .match-card {
      position: relative;
      min-height: 420px;
      padding: 20px 15px;
      color: ${theme.colors.white};
    }

    .match-state-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      z-index: 2;
    }

    .league-badge {
      padding: 10px 0;
      margin: 0 auto;
      text-align: center;
      text-transform: uppercase;
      font-family: ${displayFont} !important;
      font-size: 26px;
      font-weight: 400;
      line-height: 1.2;
      background: linear-gradient(
          90deg,
          rgb(246, 225, 158) 0%,
          rgb(223, 172, 62) 50%,
          rgb(246, 225, 158) 100%
        )
        text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .match-time-row {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: fit-content;
      max-width: 100%;
      margin: 10px auto 0;
      padding: 10px 20px;
      color: ${theme.colors.white};
      font-family: ${bodyFont} !important;
      font-size: 18px;
      font-weight: 500;
      line-height: 1;
      text-align: center;
      white-space: nowrap;
    }

    .match-time-row::before,
    .match-time-row::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 255, 255, 0.95) 53.22%,
        transparent 100%
      );
      opacity: 0.9;
    }

    .match-time-row::before {
      top: 0;
    }

    .match-time-row::after {
      bottom: 0;
    }

    .time-dot {
      font-size: 0.9em;
      opacity: 0.88;
    }

    .match-time {
      font-weight: 600;
    }

    .match-timezone {
      font-weight: 400;
      opacity: 0.92;
    }

    .match-hero {
      position: relative;
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
      align-items: center;
      gap: 28px;
      margin-top: 15px;
      padding: 10px 20px;
    }

    .match-hero.is-loading {
      margin-top: 32px;
    }

    .team-block {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      min-width: 0;
    }

    .team-logo-shell {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      height: 120px;
      filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.38));
    }

    .team-logo,
    .team-logo-fallback {
      width: 100%;
      height: 100%;
    }

    .team-logo {
      display: block;
      object-fit: contain;
    }

    .team-logo-fallback {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 2px solid rgba(255, 255, 255, 0.72);
      background: rgba(255, 255, 255, 0.14);
      color: ${theme.colors.white};
      font-family: ${displayFont} !important;
      font-size: clamp(1.1rem, 1rem + 0.6vw, 1.8rem);
      font-weight: 800;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }

    .team-odds {
      color: ${theme.colors.white};
      font-family: ${displayFont} !important;
      font-size: 20px;
      font-weight: 500;
      line-height: 1;
    }

    .versus {
      position: relative;
      z-index: 1;
      width: 75px;
      height: 75px;
      filter: drop-shadow(0 4px 0 rgba(130, 68, 0, 0.85))
        drop-shadow(0 10px 18px rgba(0, 0, 0, 0.7));

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .match-footer {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin-top: 6px;
    }

    .team-caption {
      min-width: 0;
      margin-top: 10px;
      text-align: center;
    }

    .team-name {
      margin: 0;
      color: ${theme.colors.white};
      font-family: ${displayFont} !important;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.1;
      text-shadow: 0 1px 0 rgba(143, 73, 0, 0.95), 0 6px 12px rgba(0, 0, 0, 0.5);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .team-side-label {
      display: block;
      margin-top: 4px;
      color: rgba(255, 255, 255, 0.95);
      font-family: ${bodyFont} !important;
      font-size: 18px;
      font-weight: 400;
      line-height: 1.15;
      text-shadow: 0 1px 0 rgba(143, 73, 0, 0.95), 0 6px 12px rgba(0, 0, 0, 0.5);
    }

    .action-button {
      align-self: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 140px;
      height: 60px;
      border: 0;
      background-color: transparent;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      box-shadow: none;
      color: #fffef0;
      font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
      font-size: 20px;
      font-weight: 500;
      line-height: 1;
      letter-spacing: 0;
      text-transform: uppercase;
      cursor: pointer;
      text-shadow: 2px 3px 1px rgba(143, 73, 0, 0.95),
        0 6px 12px rgba(0, 0, 0, 0.5);
      filter: drop-shadow(0, 0, 0, #000);
      transition: transform 0.2s ease, opacity 0.2s ease;

      ${media.md} {
        min-width: 120px;
        height: 50px;
        font-size: 16px;
      }
    }

    .action-button:hover {
      opacity: 0.96;
      transform: translateY(-1px);
    }

    .market-summary {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: baseline;
      gap: 14px;
      margin-top: 8px;
      color: ${theme.colors.white};
      font-family: ${bodyFont} !important;
      text-shadow: 0 1px 0 rgba(143, 73, 0, 0.95), 0 6px 12px rgba(0, 0, 0, 0.5);
    }

    .market-label {
      font-size: 16px;
      font-weight: 700;
      text-transform: uppercase;
    }

    .market-value {
      font-size: 16px;
      font-weight: 400;
    }

    .state-message {
      position: relative;
      z-index: 2;
      max-width: 220px;
      margin: auto;
      color: ${theme.colors.white};
      font-family: ${bodyFont} !important;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.4;
      text-align: center;
      text-shadow: 0 6px 12px rgba(0, 0, 0, 0.35);
    }

    .state-message-empty {
      opacity: 0.9;
    }

    ${media.lg} {
      .match-card {
        min-height: 380px;
        padding: 18px 14px;
      }

      .match-stadium-layer {
        bottom: 15%;
        max-height: 124px;
      }

      .league-badge {
        font-size: 22px;
      }

      .match-time-row {
        font-size: 16px;
      }

      .match-hero {
        gap: 18px;
        margin-top: 30px;
        padding: 0 10px;
      }

      .team-logo-shell {
        width: 96px;
        height: 96px;
      }

      .team-odds,
      .team-name {
        font-size: 18px;
      }

      .team-side-label {
        font-size: 16px;
      }

      .versus {
        width: 68px;
        height: 68px;
      }
    }

    ${media.md} {
      .match-card {
        min-height: 0;
        padding: 15px 12px;
      }

      .league-badge {
        padding: 5px 0;
        font-size: 20px;
      }

      .match-time-row {
        gap: 8px;
        margin-top: 5px;
        padding: 5px 10px;
        font-size: 14px;
      }

      .match-stadium-layer {
        bottom: 16%;
        max-height: 92px;
      }

      .match-hero {
        gap: 10px;
        margin-top: 30px;
        padding: 0;
      }

      .team-block {
        gap: 10px;
      }

      .team-logo-shell {
        width: 80px;
        height: 80px;
      }

      .team-odds {
        font-size: 14px;
      }

      .versus {
        width: 64px;
        height: 64px;
      }

      .team-caption {
        margin-top: 4px;
      }

      .team-name {
        font-size: 16px;
      }

      .team-side-label {
        font-size: 14px;
      }

      .action-button {
        min-width: 120px;
        height: 50px;
        padding: 0 14px;
        font-size: 16px;
      }

      .market-summary {
        margin-top: 5px;
      }

      .market-label,
      .market-value {
        font-size: 13px;
      }
      .state-message {
        font-size: 14px;
      }
    }

    ${media.sm} {
      .match-card {
        padding: 14px 10px;
      }

      .league-badge {
        font-size: 18px;
      }

      .match-time-row {
        gap: 6px;
        width: 100%;
        padding: 6px 8px;
        font-size: 12px;
      }

      .match-hero {
        grid-template-columns: minmax(0, 1fr) 56px minmax(0, 1fr);
        gap: 8px;
        margin-top: 24px;
      }

      .team-block {
        gap: 8px;
      }

      .team-logo-shell {
        width: 64px;
        height: 64px;
      }

      .versus {
        width: 56px;
        height: 56px;
      }

      .team-name {
        font-size: 14px;
      }

      .team-side-label {
        font-size: 12px;
      }

      .action-button {
        min-width: 108px;
        height: 44px;
        font-size: 14px;
      }
    }
  `,
};
